export default __webpack_public_path__ + "static/media/safeguarding-policy.aa9c7dfb.md";